import React, { createContext, useContext, useEffect } from "react";
import { getPosts, PostWithItems } from "../../services/PostServices";
import {
  usePaginatedData,
  UsePaginatedDataResult,
} from "../helper/usePaginatedData";
import { useFetchedUserContext } from "./FetchedUser";

interface PostContextProps {
  postsState: UsePaginatedDataResult<PostWithItems>;
}

const FetchedUserPostContext = createContext<PostContextProps | undefined>(
  undefined
);

export const FetchedUserPostProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const postsState = usePaginatedData<PostWithItems>();

  const { user } = useFetchedUserContext();

  const limit = 8;

  useEffect(() => {
    if (user && postsState.page > 0) postsState.fetchData(limit, getPosts);

    // only rerun on page change ...
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postsState.page]);

  useEffect(() => {
    postsState.setPage(0);
    postsState.setHasMore(true);
    postsState.setFilteredData([]);
    postsState.setData([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <FetchedUserPostContext.Provider
      value={{
        postsState,
      }}
    >
      {children}
    </FetchedUserPostContext.Provider>
  );
};

export const useFetchedUserPostsContext = () => {
  const context = useContext(FetchedUserPostContext);
  if (!context) {
    throw new Error(
      "usePostContext must be used within a FetchedUserPostContext"
    );
  }
  return context;
};
